import React from 'react'
import { GrMoney } from "react-icons/gr";
import { FiTruck } from "react-icons/fi";
import { RiBookOpenLine } from "react-icons/ri";
import { MdArrowForwardIos } from "react-icons/md";
import { useNavigate } from 'react-router-dom';

export const Details = () => {
  const navigate = useNavigate()

  const steps = [
    {
      "title": "Find eller sælg",
      "desc": "Kig efter en brugt bog - eller opret din egen annonce på få minutter"
    },
    {
      "title": "Køb & forsendelse",
      "desc": "Køberen betaler fragt. Der oprettes automatisk et pakkelabel som sælgeren benytter til at afsende pakken."
    },
    {
      "title": "Pengene udbetales",
      "desc": "Når overdragelsen er godkendt af køberen, overføres pengene til sælgerens saldo, hvorefter de kan udbetales."
    }
  ]

  return (
    <div className="py-16">
      <div className="innerContainer mx-auto space-y-10">
        <h2 className="text-2xl md:text-4xl font-bold text-center md:text-left"><span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-600 to-emerald-700 bg-pos-0 bg-size-200">Sådan</span> fungerer det</h2>
        <div className="steps flex flex-col md:flex-row justify-between gap-y-10 md:gap-x-5 lg:gap-x-10 text-center md:text-left sm:w-[75%] md:w-auto mx-auto">
          {steps.map((step, index) => {
            return (
              <>
                <div className="space-y-4 w-full">
                  {index === 2 ? <GrMoney className="text-5xl mx-auto md:mx-0" /> : index === 1 ? <FiTruck className="text-5xl mx-auto md:mx-0" /> : <RiBookOpenLine className="text-5xl mx-auto md:mx-0" />}
                  <div className="text space-y-1">
                    <h2 className="font-semibold">{step.title}</h2>
                    <p className="">{step.desc} {index === 0 && <span className="underline cursor-pointer" onClick={() => navigate('/sælgbog')}>her</span>}{index === 0 && "."}</p>
                  </div>
                </div>
                {index === 0 || index === 1 ?
                  <div className="content-center">
                    <MdArrowForwardIos className="text-xl rotate-[90deg] md:rotate-[0deg] mx-auto md:mx-0" />
                  </div>
                :
                  ""
                }
              </>
            )
          })}
        </div>
        <p className="text-sm text-neutral-500">Klik <span className="underline cursor-pointer text-emerald-500" onClick={() => navigate('/hjælp')}>her</span> for at læse mere om køb og salg på BogBanken.dk</p>
      </div>
    </div>
  );
};